<div class="address-picker-container">
    <agm-map [latitude]="mapLatitude" [(zoom)]="zoom" [longitude]="mapLongitude" [disableDefaultUI]="true">
        <agm-zoom-control></agm-zoom-control>
        <agm-marker [latitude]="markerLatitude"
                    [longitude]="markerLongitude"
                    [markerDraggable]="true"
                    [iconUrl]="markerUrl"
                    (dragEnd)="markerMoved($event)">
        </agm-marker>
        <agm-circle [latitude]="markerLatitude"
                    [longitude]="markerLongitude"
                    [circleDraggable]="false"
                    [radius]="radius"
                    [fillColor]="'#0078bf'"
                    [fillOpacity]="0.2"
                    [strokeColor]="'#0078bf'"
                    [strokeWeight]="2">
        </agm-circle>
    </agm-map>

    <div class="address-picker-overlay">
        <button class="btn btn-default m-r-sm" *ngIf="dirtyPosition" (click)="cancel()">
            <i class="fa fa-ban"></i>
            <span [i18n]="[{target: 'innerHTML', key: 'buttons.cancel'}]"></span>
        </button>
        <button class="btn btn-primary" *ngIf="dirtyPosition" (click)="save()">
            <i class="fa fa-save"></i>
            <span [i18n]="[{target: 'innerHTML', key: 'buttons.save'}]"></span>
        </button>
    </div>
</div>
